import React from 'react';
import { useSelector } from 'react-redux';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import ZendeskFAQs from '../presentational/ZendeskFAQs';
import useTranslate from 'lib/languages/useTranslate';
import { selectCurrentLanguage } from 'lib/slices';
import { useGetZendeskCategoriesQuery } from 'lib/services';

const ZendeskFAQsContainer = () => {
    const language = useSelector(selectCurrentLanguage);

    const { data, error, isFetching } = useGetZendeskCategoriesQuery(language, {
        skip: !language,
    });

    const translate = useTranslate('faqs');

    return (
        <DataCheck
            data={data}
            isLoading={isFetching}
            error={error}
            noDataMessage={translate('noDataMessage')}
        >
            <ZendeskFAQs faqs={data} />
        </DataCheck>
    );
};

export default ZendeskFAQsContainer;
